export const pluralize = (word: string, count: number, shouldAddEBeforeS = false) => {
    if (count === 1) {
        return word;
    }
    return `${word}${shouldAddEBeforeS ? 'e' : ''}s`;
};
